import { render } from "./RecuperarContrasena.vue?vue&type=template&id=64765113&scoped=true"
import script from "./RecuperarContrasena.vue?vue&type=script&lang=js"
export * from "./RecuperarContrasena.vue?vue&type=script&lang=js"

import "./RecuperarContrasena.vue?vue&type=style&index=0&id=64765113&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64765113"]])

export default __exports__